import 'core-js/fn/object/assign';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, browserHistory } from 'react-router';

import App from './components/Main';
import Explore from './components/ExploreComponent';
import Albums from './components/AlbumsComponent';
import Login from './components/LoginComponent';
import Forget from './components/ForgetComponent';
import Regist from './components/RegistComponent';
import MediaDetail from './components/MediaDetailComponent';
// import AlbumDetail from './components/AlbumDetailComponent';
import Publish from './components/PublishComponent';
import Comments from './components/CommentsComponent';
import Collect from './components/CollectComponent';
import LocationMore from './components/LocationMoreComponent';
import MapDetail from './components/MapDetailComponent';
import AlbumArticle from './components/AlbumArticleComponent';
import AlbumEdit from './components/AlbumEditComponent';
import Opportunities from './components/OpportunitiesComponent';
import OpportunityDetail from './components/OpportunityDetailComponent';
import OpportunityReferral from './components/OpportunityReferralComponent';
import Result from './components/ResultComponent';

// ************************************** Business *********************************************
// import AArticle from './components/AArticleComponent'
import AgentArticle from './components/AgentArticleComponent'
import Agent from './components/AgentComponent'

// import BArticle from './components/BArticleComponent'
import BuisnessArticle from './components/BusinessArticleComponent'
import Business from './components/BusinessComponent'

import Businesses from './components/BusinessesComponent'
import NewBusiness from './components/NewBusinessComponent'
import AgentActive from './components/AgentActiveComponent'
// ************************************** Business *********************************************

// ************************************** Store *********************************************
import Store from './develop/StoreComponent'
import Routex from './develop/RouteComponent'
import Checkout from './develop/CheckoutComponent'
import Teams from './develop/TeamsComponent'
// ************************************** Store *********************************************

// ************************************** Profile *********************************************
import User from './components/UserComponent';
import Profile from './components/ProfileComponent';
import Followings from './components/FollowingsComponent';
import Followers from './components/FollowersComponent';
import Collects from './components/CollectsComponent';
import Orders from './components/OrdersComponent';
import Favorites from './components/FavoritesComponent';
import Links from './components/LinksComponent';
import FootPrints from './components/FootPrintsComponent';
import MyMedias from './components/MyMediasComponent';
import MyAlbums from './components/MyAlbumsComponent';
import Setting from './components/SettingComponent';
// ************************************** Profile *********************************************

// ************************************** Search *********************************************
import Search from './develop/SearchComponent'
// ************************************** Search *********************************************

// ************************************** Destinations *********************************************
import Destinations from './develop/DestinationsComponent'
import Feature from './develop/FeatureComponent'
// ************************************** Destinations *********************************************


import API from './sources/API';
import UserActions from 'actions/UserActions';

// 登录流程
if(API.isWechat) { //是否微信浏览器
    if(API.accessToken) {   //已登录
        let params = {
            method: 'POST',
            headers: API.jsonHeader,
            body: JSON.stringify({accessToken: API.accessToken})
        };
        fetch(API.postAccessTokenExamine, params)
            .then(res=>res.json())
            .then(json=>{
                if(json.status === 1) {
                    console.log(`postAccessTokenExamine ${json.msg}`);  // token不能用
                    location.href = API.redirectWechatLogin;
                } else {
                    if(json.accessToken) {
                        UserActions.updateToken(json.accessToken);
                    }
                }
            });
    } else { // 未登录
        if(/_xdq/.test(location.search)) {  //是否需要验证登录
            var searchParams = location.search;
            fetch(`${API.getAccessToken}${searchParams}`)
                .then(res=>res.json())
                .then(json=>{
                    if(json.status === 1){
                        console.log(`getAccessToken ${json.msg}`);  // 没拿到token
                        location.href = API.redirectWechatLogin;
                    } else {
                        console.log(json);
                        if(json.accessToken) {
                            UserActions.updateToken(json.accessToken);
                            if(/Android/.test(navigator.userAgent)) {
                                location.href = `${location.origin}${location.pathname}`;
                            }
                        }
                    }
            });
        }
    }
    fetch(API.getWechatConfig).then(res=>res.json()).then(json=>{
        console.log(json);
        if(json.appId) {
            window.wx.config(json);
        }
    })
}

ReactDOM.render((
    <Router history={browserHistory}>
        <Route path="/" component={Store} />
        <Route path="/medias(/:page)" component={Explore} />
        <Route path="/media/:id" component={MediaDetail} />
        <Route path="/publish" component={Publish} />
        <Route path="/media/:id/comments" component={Comments} />
        <Route path="/map" component={MapDetail} />
        <Route path="/albums(/:page)" component={Albums} />
        {/* <Route path="/album/:id" component={AlbumDetail} /> */}
        <Route path="/album/:id/edit" component={AlbumEdit} />
        <Route path="/article/:id" component={AlbumArticle} />
        {/* <Route path="/profile" component={User} /> */}
        <Route path="/center" component={Profile} />
        <Route path="/followings" component={Followers} />
        <Route path="/followers" component={Followings} />
        <Route path="/collects" component={Collects} />
        <Route path="/favorites" component={Favorites} />
        <Route path="/links" component={Links} />
        <Route path="/foots" component={FootPrints} />
        <Route path="/my/medias" component={MyMedias} />
        <Route path="/my/albums" component={MyAlbums} />
        <Route path="/orders" component={Orders} />
        <Route path="/orders/:id" component={Orders} />
        <Route path="/setting" component={Setting} />
        <Route path="/user/:id" component={User} />
        <Route path="/login" component={Login} />
        <Route path="/forget" component={Forget} />
        <Route path="/regist" component={Regist} />
        <Route path="/media/:id/collect" component={Collect} />
        <Route path="/location" component={LocationMore} />
        <Route path="/opportunities" component={Opportunities} />
        <Route path="/opportunity/:id" component={OpportunityDetail} />
        <Route path="/opportunity/:id/referral" component={OpportunityReferral} />
        <Route path="/search" component={Search} />
        <Route path="/store" component={Store} />
        <Route path="/destinations" component={Destinations} />
        <Route path="/feature/:id" component={Feature} />
        <Route path="/teams" component={Teams} />
        <Route path="/route/:id" component={Routex} />
        <Route path="/checkout/:id" component={Checkout} />
        <Route path="/product/:id" component={Store} />
        <Route path="/result/:action" component={Result} />
        <Route path="/businesses/:id" component={Businesses} />
        <Route path="/business/:id" component={Business} />
        <Route path="/new/business" component={NewBusiness} />
        <Route path="/agent/active" component={AgentActive} />
        <Route path="/agent/:id" component={Agent} />
        <Route path="/business/:bid/article/:id" component={BuisnessArticle} />
        <Route path="/agent/:aid/article/:id" component={AgentArticle} />
        {/* <Route path="/a/:aid/article/:id" component={AArticle} />
        <Route path="/b/:bid/article/:id" component={BArticle} /> */}
        <Route path="/*" component={Explore} />
        <Route path="/*.*" component={Explore} />
    </Router>
), document.getElementById('app'))


// WEBPACK FOOTER //
// ./src/index.js